import { createEvent, createEffect, sample } from 'effector';
import { ModelContract, ModuleDescription } from '../module-description';
import { HttpRequest } from "@features/shared/request/model";

export const setToken = createEvent<string>();
export const removeToken = createEvent();

const setTokenFx = createEffect(async (value: string) => {
    await HttpRequest.tokenStorage.setToken(value);
});

const removeTokenFx = createEffect(async () => {
    await HttpRequest.tokenStorage.removeToken();
});

sample({
    clock: setToken,
    filter: (value) => Boolean(value),
    target: setTokenFx,
});

sample({
    clock: removeToken,
    target: removeTokenFx,
});


const contract = new ModelContract(
    {},
    {
        setToken,
        removeToken
    },
    {},
    {}
);

export type ITokenStorageContract = typeof contract;

export class TokenStorageModule extends ModuleDescription<ITokenStorageContract> {
    getDefaultContract() {
        return contract;
    }
}
